import moment, { isMoment } from 'moment';
import { FieldDataStrings as Strings } from './config'

export const getFieldTypeString = (fieldType) => {
    switch (fieldType) {
        case 'HTML':
            return Strings.htmlField;
        case 'PageLink':
            return Strings.linkField;
        case 'Checkbox':
            return Strings.checkboxField;
        case 'Asset':
            return Strings.assetField;
        case 'Dropdown':
            return Strings.dropdownField;
        case 'List':
            return Strings.listField;
        case 'Date':
            return Strings.dateField;
        case 'DateTime':
            return Strings.dateTimeField;
        case 'Text':
        default:
            return Strings.textField;
    }
}

export const scaleScreenTypes = Object.freeze({
    DYNAMIC: 0,
    DESKTOP: 1,
    TABLET: 2,
    MOBILE: 3,
})

export const getScalingScreenTypeDimensions = (scalingScreenType) => {
    switch (scalingScreenType) {
        case scaleScreenTypes.DESKTOP:
            return {
                scaleRatioDenominator: 1920,
                width: '1920px',
                height: '1080px'
            }
        case scaleScreenTypes.TABLET:
            return {
                scaleRatioDenominator: 768,
                width: '768px',
                height: '1024px'
            }
        case scaleScreenTypes.MOBILE:
            return {
                scaleRatioDenominator: 375,
                width: '375px',
                height: '812px'
            }
        case scaleScreenTypes.DYNAMIC:
        default:
            return {
                scaleRatioDenominator: window.innerWidth,
                width: '100vw',
                height: '100vh'
            }
    }
}

export function toMoment(value) {
    if(isMoment(value)) {
        return value
    }

    if(typeof value === 'string') {
        return moment(value)
    }

    return moment(0, "HH") // Defaults to start of day
}
